module.exports = __webpack_public_path__ + "static/pic03-35fb3973beee68ad0e7d4d717f6ca605.jpg";